import React from "react";
import "./loader.css";

const Loader = () => {
  return (
    <div class="spinner-box">
      <div class="three-quarter-spinner"></div>
    </div>
  );
};

export default Loader;
